import { atom } from 'jotai';

export const blogSearch = atom<string>('');
